import { render, staticRenderFns } from "./EditAcceptPendingProductsDialog.vue?vue&type=template&id=58e72302"
import script from "./EditAcceptPendingProductsDialog.vue?vue&type=script&lang=js"
export * from "./EditAcceptPendingProductsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports